import React from 'react';
export const NotFound = React.lazy(() => import('./NotFound'));